<template>
    <div style="padding: 20px;width: 100%;height: 100%">
        <div class="titleBox" style="display: flex;align-items: center;">
            <img src="../../../assets/img/icon.png" alt="" style="width: 24px">
            <h3>调解确认案件</h3>
        </div>
        <div class="caseNumBox">
            <div>
                <h4>调解确认案件</h4>
                <p>共计：{{allData.tiaojie_total_num}}件</p>
            </div>
            <div>
                <h4>总金额</h4>
                <p>共计：{{allData.tiaojie_total_money}}元</p>
            </div>
        </div>
        <dv-scroll-ranking-board
            :config="config"
            style="width: 98%; height: 60%; margin-left: 2%;"
        />
    </div>
</template>

<script>
export default {
    name:'tj_confirmCase',
    props:['allData'],
    data(){
        return{
            tj_Data:'',
            config: {
                data: [
                    {
                        name: "立案数量",
                        value: '',
                    },
                    {
                        name: "撤案数量",
                        value: '',
                    },
                    {
                        name: "结案数量",
                        value: '',
                    },
                ],
                sort:false,
            },
        }
    },
    watch: {
        allData: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (!newVal) return;
                // 全量替换配置数据（触发响应式更新）
                this.config  = {
                    ...this.config,
                    data: this.config.data.map(item  => ({
                        ...item,
                        value: newVal[this.getPropKey(item.name)] || 0
                    }))
                };
            }
        }
    },
    methods: {
        getPropKey(name) {
            const mapping = {
                "立案数量": "tiaojie_lian_num",
                "撤案数量": "tiaojie_chean_num",
                "结案数量": "tiaojie_jiean_num"
            };
            return mapping[name];
        }
    }
}

</script>

<style scoped lang="scss">
.titleBox{
    img{
        margin-right: 10px;
    }
}
.caseNumBox{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
    div{
        padding: 10px;
        width: 43%;
        background-image: linear-gradient(to top, #03255e, #121d32);
        border-radius: 5px;
        p{
            margin-top: 5px;
        }
    }
}
::v-deep.dv-scroll-ranking-board .ranking-info .rank{
    width: 0px;
}
::v-deep.dv-scroll-ranking-board{
    .row-item {
        .ranking-info{
            .rank{
                font-size: 0;

            }
        }
    }
}
</style>